import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"z-index":"99999999","bottom":"50px"},
  role: "alert",
  "aria-live": "assertive",
  "aria-atomic": "true",
  class: "toast position-fixed ms-5",
  id: "main-toast",
  "data-bs-autohide": "false"
}
const _hoisted_2 = { class: "toast-header border-0 pb-1" }
const _hoisted_3 = { class: "me-auto ms-2 text-subtitle" }
const _hoisted_4 = { class: "toast-body pt-0 pb-4 text-muted text-paragraph" }
const _hoisted_5 = { class: "progress progress-sm" }

import { ref, onMounted } from "vue";
import { Toast } from "bootstrap";
// @ts-ignore
import $ from "jquery";
import { EventBus, EventBusNames } from "@/utils/EventBus";


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationToast',
  setup(__props) {

const filledProgressToast = ref<HTMLElement | null>(null);
const toast = ref<Toast | null>(null);
const title = ref("");
const msg = ref("");

const handleToast = (data: { title: string; msg: string }) => {
  toast.value = new Toast(document.getElementById("main-toast")!);
  title.value = data.title;
  msg.value = data.msg;
  toast.value.show();
  $(filledProgressToast.value as HTMLElement).animate(
    { width: "0%" },
    3500,
    function () {
      setTimeout(() => {
        // @ts-ignore
        $(this).css("width", "100%");
      }, 500);
      toast.value?.hide();
    },
  );
};

onMounted(() => {
  EventBus.$on(EventBusNames.SHOW_TOAST, handleToast);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fa-solid fa-check-circle text-primary" }, null, -1)),
      _createElementVNode("strong", _hoisted_3, _toDisplayString(title.value), 1),
      _cache[1] || (_cache[1] = _createElementVNode("button", {
        type: "button",
        class: "btn-close",
        "data-bs-dismiss": "toast",
        "aria-label": "Close"
      }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("small", null, _toDisplayString(msg.value), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        ref_key: "filledProgressToast",
        ref: filledProgressToast,
        id: "filled-progress-toast",
        class: "progress-bar",
        role: "progressbar",
        style: {"width":"100%"},
        "aria-valuemin": "0",
        "aria-valuemax": "100"
      }, null, 512)
    ])
  ]))
}
}

})